<script>
import { Bar } from "vue-chartjs";

export default {
  name: "BarExpenseEvolution",
  extends: Bar,
  props: {
    chartData: { type: Object, default: null },
    height: { type: Number, default: 280 }
  },
  watch: {
    chartData(val) {
      if (val) this.render(val);
    }
  },
  mounted() {
    if (this.chartData) this.render(this.chartData);
  },
  methods: {
    render(data) {
      this.renderChart(
        {
          labels: data.labels,
          datasets: [
            {
              label: "Gastos",
              data: data.values,
              backgroundColor: "#2d2b55",
              hoverBackgroundColor: "#534ab7",
              borderRadius: 5,
              borderSkipped: false
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            xAxes: [
              {
                gridLines: { display: false },
                ticks: { fontSize: 11, fontColor: "#888" }
              }
            ],
            yAxes: [
              {
                gridLines: { color: "#f0f2f7" },
                ticks: {
                  fontSize: 11,
                  fontColor: "#888",
                  precision: 0,
                  callback: v => "$" + Number(v).toLocaleString("es-EC")
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: ctx =>
                " $" +
                Number(ctx.yLabel).toLocaleString("es-EC", {
                  minimumFractionDigits: 2
                })
            }
          }
        }
      );
    }
  }
};
</script>
